// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
    togglePickWave({ commit }, build) {
        commit("toggle_pickwave", build);
    },
    getBuildPickability(context) {
        context.commit("reset_error");
        context.commit("set_loading",true);
        return new Promise(resolve => {
            NewApiService.get("pickwave/build-pickability")
            .then(({ data }) => {
                context.commit("set_loading",false);
                context.commit("set_buildPickability",data.builds);
                resolve(data);
            })
            .catch(({ response }) => {
                context.commit("set_error", response.data.errors);
            });
        });
    },
    createAndStartPickWave(context, orderIds) {
        context.commit("set_loading",true);
        context.commit("reset_error");
        context.commit("reset_buildInPickwave")
        return new Promise(resolve => {
            NewApiService.put("pickwave/create-start-pickwave", {orderIds})
            .then(({ data }) => {
                context.commit("set_loading",false);
                resolve(data);
            })
            .catch(({ response }) => {
                context.commit("set_error", response.data.message);
            });
        }); 
    },
    getPickWave(context, pickWaveId) {
        context.commit("reset_error");
        context.commit("set_loading",true);
        return new Promise(resolve => {
            NewApiService.get("pickwave/"+pickWaveId)
            .then(({ data }) => {
                context.commit("set_loading",false);
                context.commit("set_pickWave",data.pickwave);
                resolve(data);
            })
            .catch(({ response }) => {
                context.commit("set_error", response.data.errors);
            });
        }); 
    },
    getPickWaves(context,params) {
        context.commit("reset_error");
        context.commit("set_loading");
        const {pagination, search, filters, expand} = params
    
        var filter = [];
        Object.keys(filters).forEach((key) => {
            filter[key] = filters[key]
        });
    
        let sort = pagination.sortBy[0];
    
        if(pagination.sortDesc[0] == false){
          sort = '-'+sort;
        }
        let page = pagination.page
        let rows_per_page = pagination.itemsPerPage
    
    
        return new Promise(resolve => {
          NewApiService.get("pickwave", {
            sort, page, search, filter, expand, rows_per_page
          })
            .then(({ data }) => {
                context.commit("set_loading",false);
                context.commit("set_pickWaves",data.pickwaves);
              resolve(data);
            })
            .catch(({ response }) => {
              context.commit("set_error", response.data.errors);
            });
        });
      },

    getPickingLocations(context, pickWaveId) {
        context.commit("reset_error");
        context.commit("set_loading",true);
        return new Promise(resolve => {
            NewApiService.get("pickwave/"+pickWaveId+"/picking-locations")
            .then(({ data }) => {
                context.commit("set_loading",false);
                context.commit("set_pickingLocations",data.pickingLocations);
                resolve(data);
            })
            .catch(({ response }) => {
                context.commit("set_error", response.data.errors);
            });
        }); 
    },
    pickItem(context, params){
        context.commit("pick_item",params);
    },
    resetPicking(context, itemIndex){
        context.commit("reset_picking",itemIndex);
    },
    commitPickup({state,commit}, pickWaveId){
        commit("reset_error");
        commit("set_loading",true);

        // `taskId` désigne la ligne sans ambiguïté : des variantes partagent
        // le même code produit, et le serveur pouvait prendre le mauvais.
        let pickingList = state.pickingLocations.map(item => {
            return {
                taskId: item.id,
                code: item.product.code,
                locationId: item.location.id,
                picked: item.picked
            }
        });

        return new Promise(resolve => {
            NewApiService.put("pickwave/"+pickWaveId+"/commit-pickup", {pickingList})
            .then(({ data }) => {
                commit("set_loading",false);
                resolve(data);
            })
            .catch(({ response }) => {
                commit("set_error", response.data.errors);
            });
        });
    },
    completePickWave(context, pickWaveId) {
        context.commit("reset_error");
        context.commit("set_loading",true);
        return new Promise(resolve => {
            NewApiService.put("pickwave/"+pickWaveId+"/complete")
            .then(({ data }) => {
                context.commit("set_loading",false);
                resolve(data);
            })
            .catch(({ response }) => {
                context.commit("set_error", response.data.errors);
            });
        });
    }
}